import Hero from "../components/Hero";
import Footer from "../components/Footer";
import Bucketlist from "../components/Bucketlist";
import Backtotop from "../components/Backtotop";
import Quote from "../components/Quote";
import ComingSoon from "../components/Comingsoon";
import { useTravelMetaContext } from "../features/travel/TravelContext";
import { DestinationsSection, FiltersPanel, Header } from "../features/travel/components";

const TravelJournalPage = () => {
  const { isLoading, error } = useTravelMetaContext();
  const isContentReady = !isLoading;

  return (
    <>
      <Header />
      <Hero />
      <main className={isContentReady ? "page-fade-in" : "page-fade-pending"}>
        {error ? <div className="cards-no-results">{error}</div> : null}
        {!isLoading && !error ? <FiltersPanel /> : null}
        {!isLoading && !error ? <DestinationsSection /> : null}
      </main>
      <Quote />
      <Bucketlist />
      <ComingSoon />
      <Footer />
      <Backtotop />
    </>
  );
};

export default TravelJournalPage;
